//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    venues_list,
    playingField_list,
    timeSlot_insert
} from '@/apis/stadium'
import { service_list } from '@/apis/product'
import TimeSpan from '@/components/TimeSpan.vue';

export default {
    components: {
        TimeSpan
    },
    data() {
        const rules = {
            name: [{ required: true, message: '請輸入場次名稱！' }],
            venueCode: [{ required: true, message: '請選擇所屬場館！' }],
            fieldCode: [{ required: true, message: '請選擇所屬場地！' }],
            serviceTypeCode: [{ required: true, message: '請選擇產品標籤！' }],
            serviceId: [{ required: true, message: '請選擇產品事件！' }],
            businessHours: [{ required: true, message: '請選擇時段！' }],
            status: [{ required: true, message: '請選擇狀態！' }],
            //timeSlots: [{ required: true, message: '請選擇時間範圍！' }],
            date: [{ required: true, message: '請選擇日期！' }],
        };

        const form = {
            name: undefined,
            venueCode: undefined,
            fieldCode: undefined,
            serviceTypeCode: undefined,
            serviceId: undefined,
            businessHours: undefined,
            timeSlots: undefined,
        };

        return {
            isLoading: false,
            config: {
                gymnasiums: [],
                fields: [],
                services: []
            },
            form,
            rules,
            timeSpanArr: [{
                timespan: '',
                startTime: "",
                endTime: "",
                price: '',
                type: ''
            }],
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        };
    },
    async mounted() {
        await this.onPageConfig();
    },
    methods: {
        async getVenues() {
            try {
                //加載所屬場館
                const res = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.gymnasiums = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getField() {
            try {
                const res = await playingField_list({ fieldName: '', venueCode: this.form.venueCode, status: '', sportTypeCode: '', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.fields = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getService() {
            try {
                const res = await service_list({ venueCode: this.form.venueCode, type: '', typeCode: this.form.serviceTypeCode, time: '', name: '', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.services = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageConfig() {
            await this.getVenues();
        },
        async handleGymnasiumChange() {
            this.form.fieldCode = undefined;
            this.form.serviceId = undefined;
            await this.getField();
            if ((this.form.serviceTypeCode || '') != '') {
                //存在產品標籤的時候進行產品的查詢
                await this.getService();
            } else {
                this.config.services = [];
            }

        },
        async handleServiceTypeChange() {
            this.form.serviceId = undefined;
            if ((this.form.venueCode || '') != '') {
                //存在場館時候進行產品的查詢
                await this.getService();
            } else {
                this.config.services = [];
            }
        },
        handleDelTimeSpan(index) {
            let timeSpanArr = this.timeSpanArr || [];
            timeSpanArr.splice(index, 1);
            this.timeSpanArr = timeSpanArr;
        },
        handleAddTimeSpan() {
            let timeSpanArr = this.timeSpanArr || [];
            timeSpanArr.push({
                timespan: '',
                startTime: "",
                endTime: "",
                price: '',
                type: ''
            });
            this.timeSpanArr = timeSpanArr;
        },
        handleOnFormValidate(e, v) {
            e.preventDefault();
            this.assembleTimeSolt();
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    if (this.form.timeSlots && this.form.timeSlots.length > 0) {
                        this.onSubmit();
                    } else {
                        this.$message.warning('提交完成');
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleOnChangeTimeSpan() {
            this.$refs.timeSpanArr.clearValidate();
        },
        assembleTimeSolt() {
            console.log(this.timeSpanArr);
            this.form.timeSlots = [];
            const date = this.form.date;
            if (!date) { return; }

            for (let i = 0; i < this.timeSpanArr.length; i++) {
                const item = this.timeSpanArr[i];
                let sDate, eDate;
                if (item.timespan) {
                    const [start, end] = item.timespan.split('-');
                    sDate = `${date} ${start}:00`
                    eDate = `${date} ${end}:00`
                }
                this.form.timeSlots.push({
                    startTime: sDate || '',
                    endTime: eDate || '',
                    price: item.price,
                    type: item.type,
                    name: this.form.name
                });
            }
        },

        // 提交表單
        async onSubmit() {
            try {
                this.isLoading = true;
                const res = await timeSlot_insert(this.form) || {};
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/matches-timeslot');
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
    }
};
